import { gql, useQuery } from '@apollo/client';

export const GET_APPLICATION_BY_ID = gql`
  query getApplicationById($id: String!) {
    getApplicationById(id: $id) {
      _id
      companyId
      healthInsuranceId
      lastDay
      firstDay
      confirmation
      status
      rejectDetails
      rejectReason
      type
      eauType
      createdBy
      fileId
      employeeId
      employee {
        employeePersonalInfo {
          employeeNumber
        }
        healthInsurance {
          _id
          name
        }
        profile {
          displayName
        }
      }
      file {
        filename
        location
        key
      }
    }
  }
`;

export const useGetApplicationById = (id?: string) => {
  const { data, loading } = useQuery(GET_APPLICATION_BY_ID, {
    variables: { id },
    skip: !id,
  });

  const application = data?.getApplicationById || {};

  return { application, loading };
};
